export const FETCHING_ORG = 'FETCHING_ORG';
export const FETCH_ORG_SUCCESS = 'FETCH_ORG_SUCCESS';
export const FETCHING_PERMISSIONS = 'FETCHING_PERMISSIONS';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAILURE = 'FETCH_PERMISSIONS_FAILURE';


// WEBPACK FOOTER //
// ./src/redux/manageUser/ManageUserConstants.js